import { observable, makeObservable } from "mobx";

export default class PatientTilesStore {
  tiles = undefined;

  constructor() {
    makeObservable(this, {
      tiles: observable,
    });
  }
}
